<template>
  <section>
    <el-page-header @back="goBack" content="SKU权益分组设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              size="mini"
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchDictionaryList"
          ></el-input>
          <el-select size="mini" v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
                v-for="item in COMMON_STATUS"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="mini" type="primary" @click="SearchDictionaryList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('equity')"
          >权益设置
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="分组名称" min-width="150">
            </el-table-column>
            <el-table-column prop="remarks" label="分组类型" min-width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.categoryType==1">测评结果内容</div>
                <div v-if="scope.row.categoryType==2">测评送题</div>
                <div v-if="scope.row.categoryType==3">进阶课程</div>
                <div v-if="scope.row.categoryType==4">会员</div>
                <div v-if="scope.row.categoryType==5">优惠券</div>
                <div v-if="scope.row.categoryType==6">错题集</div>
                <div v-if="scope.row.categoryType==7">证书</div>
                <div v-if="scope.row.categoryType==8">PDF</div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="分组描述" min-width="150">
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    type="primary"
                    v-if="editShow"
                    size="mini"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="danger"
                    plain
                    size="mini"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑/新增SKU分组"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="480px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item label="分组名称：" prop="name">
            <el-input
                clearable
                placeholder="请填写分组名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="品类类型：" prop="categoryType">
            <el-select clearable style="width: 100%" v-model="params.categoryType" filterable placeholder="请选择">
              <el-option
                  label="测评结果内容"
                  :value="1">
              </el-option>
              <el-option
                  label="测评送题"
                  :value="2">
              </el-option>
              <el-option
                  label="进阶课程"
                  :value="3">
              </el-option>
              <el-option
                  label="会员"
                  :value="4">
              </el-option>
              <el-option
                  label="优惠券"
                  :value="5">
              </el-option>
              <el-option
                  label="错题集"
                  :value="6">
              </el-option>
              <el-option
                  label="证书"
                  :value="7">
              </el-option>
              <el-option
                  label="PDF"
                  :value="8">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述：" prop="remarks">
            <el-input
                clearable
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写描述"
                v-model="params.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      loading1: false, //加载中
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写事件名称", trigger: "change"},
        ],
        categoryType: [
          {required: true, message: "请填写事件步骤", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //二级--列表
      addShow: true,
      deleteShow: true,
      editShow: true,
      statusShow: false,
      searchShow: true,
      detalisObj: {}
    };
  },
  created() {
    this.getVipRightList();
    this.getAppraisalData()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },

    SearchDictionaryList() {
      this.getVipRightList()
    },
    /**
     *  get list 分组列表
     */
    async getVipRightList() {
      let http = "/sku/group/list/"+this.$route.query.examId;
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      } else if (type == 'addNext') {
        //添加
        this.params = {};
        this.dialogVisible = true;
      } else if (type == 'equity') {
        this.$router.push({
          name:"EQUITY",
          query:{
            examId: this.$route.query.examId,
          }
        })
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.examCode = this.$route.query.examId
          const {data: resData} = await this.$post(
              "/sku/group/save",
              this.params,
              {
                headers: {
                  isLoading: true,
                  'Language-Code':'CN'
                },
              }
          );
          this.getVipRightList();
          this.dialogVisible = false
        });
      });
    },
    //删除分组
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/sku/group/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
  border: 0;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}

</style>
